import { parsePhoneNumber } from 'libphonenumber-js/max';
import { Contact } from '../../providers/api/dtos/contact';

/**
 * Checks if two contacts have the same phone number (normalized comparison)
 *
 * This function uses libphonenumber-js to normalize and compare phone numbers,
 * allowing for different formatting styles to be recognized as the same number.
 *
 * @param a - First contact to compare
 * @param b - Second contact to compare
 * @returns true if both contacts have the same phone number (after normalization), false otherwise
 *
 * @example
 * ```typescript
 * const contact1 = { phoneNumber: '+39 333 1234567' };
 * const contact2 = { phoneNumber: '3331234567' };
 * hasSamePhoneNumber(contact1, contact2); // returns true
 * ```
 */
export const hasSamePhoneNumber = (a: Partial<Contact>, b: Partial<Contact>): boolean => {
  if (!a?.phoneNumber || !b?.phoneNumber) {
    return false;
  }

  try {
    const phoneA = parsePhoneNumber(a.phoneNumber, 'IT');
    const phoneB = parsePhoneNumber(b.phoneNumber, 'IT');
    return phoneA.number === phoneB.number;
  } catch {
    return false;
  }
};
